import { render } from "./TokenWidget.vue?vue&type=template&id=ac5a73fc"
import script from "./TokenWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./TokenWidget.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/TokenWidget.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ac5a73fc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ac5a73fc', __exports__)) {
    api.reload('ac5a73fc', __exports__)
  }
  
  module.hot.accept("./TokenWidget.vue?vue&type=template&id=ac5a73fc", () => {
    api.rerender('ac5a73fc', render)
  })

}


export default __exports__